// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"_CCme4OmiMJbreAFJ5Ig","price":"oGx9ERVNGuzb06LvTfyo","subPrice":"ravHflgq7hF9w0LkzdMK"};